import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";

export interface VideoSettingsProps {
  name: string;
}

export const VideoSettings = ({ name }: VideoSettingsProps) => {
  const { watch } = useFormContext();
  const signedId = watch(`${name}.signedId`) as string;
  const hasAltText = watch(`${name}.hasAltText`) as boolean;

  const areOptionsDisabled = !signedId;

  return (
    <>
      <Form.Item
        name={`${name}.isVideoMuted`}
        label={t("builder_ui.prop_type.video_upload.mute_video")}
        hideDescription
        hideBorder
        className="!flex !items-center !p-0"
        shouldToggleValueOnLabelClick
        isDisabled={areOptionsDisabled}
      >
        <Form.ToggleSwitch
          name={`${name}.isVideoMuted`}
          variant="small"
          disabled={areOptionsDisabled}
        />
      </Form.Item>

      <Form.Item
        name={`${name}.isVideoLooped`}
        label={t("builder_ui.prop_type.video_upload.loop_video")}
        hideDescription
        hideBorder
        className="!flex !items-center !p-0"
        shouldToggleValueOnLabelClick
        isDisabled={areOptionsDisabled}
      >
        <Form.ToggleSwitch
          name={`${name}.isVideoLooped`}
          variant="small"
          disabled={areOptionsDisabled}
        />
      </Form.Item>

      <div>
        <Form.Item
          name={`${name}.hasAltText`}
          label={t("builder_ui.prop_type.video_upload.video_alt_text")}
          tooltipText={t(
            "builder_ui.prop_type.video_upload.video_alt_text_tooltip",
          )}
          hideDescription
          hideBorder
          className="!flex !items-center !p-0"
          shouldToggleValueOnLabelClick
          isDisabled={areOptionsDisabled}
        >
          <Form.ToggleSwitch
            name={`${name}.hasAltText`}
            variant="small"
            disabled={areOptionsDisabled}
          />
        </Form.Item>
        {hasAltText && (
          <Form.Item
            name={`${name}.videoAltText`}
            hideLabel
            hideDescription
            hideBorder
            className="!pt-2"
            placeholder={t(
              "builder_ui.prop_type.video_upload.video_alt_text_placeholder",
            )}
            isDisabled={areOptionsDisabled}
          >
            <Form.TextArea
              name={`${name}.videoAltText`}
              disabled={areOptionsDisabled}
            />
          </Form.Item>
        )}
      </div>
    </>
  );
};
